export default "<app-icon [iconName]=\"iconName ? iconName :'mdi:plus-circle'\"></app-icon>\r\n{{buttonText}}\r\n"